import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SORT_VIEW } from 'Common/enums';
import clsx from 'clsx';
import { shouldShowMerchants } from 'Selectors';
import RulePerformanceDashlet from '../RulePerformanceDashlet';
import { rulePerformanceRejectColumns, rulePerformanceAllColumns } from './utils';
import HeaderRows from './components/HeaderRows';

import styles from './RulePerformanceReportView.css';

type Props = {
    formValues?: ProcessedPerformanceReportFormValues;
    createdReportInfo?: CreatedReportInfo;
    newlyGenerated?: boolean;
    users?: UsersHashmap;
    reportCountData:
        | {
              [key: string]: string | number | boolean;
          }[]
        | undefined;
};

const RulePerformanceReportView = ({
    formValues,
    createdReportInfo,
    newlyGenerated,
    users,
    reportCountData
}: Props) => {
    const { t } = useTranslation();
    const [sortView, setSortView] = useState<string>(SORT_VIEW.ALPHANUMERICAL);
    // TODO: state rejectedTransactionCount not used. Verify
    const [, setRejectedTransactionCount] = useState(0);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);
    const dashletsRowCN = clsx(styles.flexRow, styles.chartsRow);
    const totalTxnCount = Number(reportCountData?.[0]?.['Performance.uniqueTransactionCount']) || 0;
    const totalRejectedTxnCount = Number(reportCountData?.[0]?.['Performance.uniqueRejectedCount']) || 0;

    const renderDashlets = () => {
        return (
            <div className={dashletsRowCN}>
                <RulePerformanceDashlet
                    formValues={formValues}
                    className={styles.top5VolumeDashletContainer}
                    minColumns={rulePerformanceRejectColumns}
                    chartType='reject'
                    sortView={sortView as SortType}
                    setRejectedTransactionCount={setRejectedTransactionCount}
                    totalRejectedTxnCount={totalRejectedTxnCount}
                />
                <RulePerformanceDashlet
                    formValues={formValues}
                    className={styles.top5ValueDashletContainer}
                    minColumns={rulePerformanceAllColumns}
                    chartType='all'
                    sortView={sortView as SortType}
                    setTotalTransactionCount={setTotalTransactionCount}
                    totalTxnCount={totalTxnCount}
                />
            </div>
        );
    };

    return (
        <div className={styles.reportViewContainer}>
            {formValues ? (
                <>
                    {formValues && (
                        <HeaderRows
                            newlyGenerated={newlyGenerated}
                            formValues={formValues}
                            sortView={sortView as SortType}
                            setSortView={setSortView}
                            createdReportInfo={createdReportInfo}
                            totalTransactions={totalTransactionCount}
                            users={users}
                        />
                    )}
                    {renderDashlets()}
                </>
            ) : (
                <>
                    <div>
                        {shouldShowMerchants()
                            ? t('newMerchantReportInstructions')
                            : t('Select a date range to generate a new report.')}
                    </div>
                    <div className={styles.newReportInstructions}>{t('newMerchantReportInstructionsPt1')}</div>
                    <div className={styles.newReportInstructions}>{t('newMerchantReportInstructionsPt2')}</div>
                </>
            )}
        </div>
    );
};

export default RulePerformanceReportView;
